import { NgModule } from '@angular/core';
import { PrizmZoneEventDirective } from './zone-event.directive';

@NgModule({
  exports: [PrizmZoneEventDirective],
  declarations: [PrizmZoneEventDirective],
})
export class PrizmZoneEventModule {}
